/**
 * The numbers a plan carries, in the order the plan editor shows them.
 *
 * Shared rather than client-side because three places read it: the plan editor,
 * the clinic detail screen, and the unit tests that run under the server's
 * TypeScript config. The keys are the same strings the API validates against
 * (admin/routes.ts PLAN_LIMIT_KEYS) - one list, two ends.
 */
export const PLAN_LIMIT_FIELDS = [
  { key: 'articles_per_month', label: '記事（店舗ごと・月）', unit: '件', scope: 'store' },
  { key: 'images_per_month', label: '画像（店舗ごと・月）', unit: '枚', scope: 'store' },
  { key: 'clinic_articles_per_month', label: '記事（クリニック合計・月）', unit: '件', scope: 'clinic' },
  { key: 'clinic_images_per_month', label: '画像（クリニック合計・月）', unit: '枚', scope: 'clinic' },
  { key: 'stores', label: '店舗数', unit: '店', scope: 'clinic' },
  { key: 'seats', label: 'ユーザー数', unit: '人', scope: 'clinic' },
  { key: 'ai_micro_cost_per_month', label: 'AI費用の上限（μUSD・月）', unit: 'μ$', scope: 'clinic' },
] as const;

export type PlanLimitKey = (typeof PLAN_LIMIT_FIELDS)[number]['key'];

